import { useState } from 'react'
import { Box, Button, Modal, OutlinedInput } from '@mui/material'
import axios from 'axios'
import { urlConfig } from '../../config/apiConfig'

export default function ForgotPassword({ open, setOpen, setError }) {
    const [email, setEmail] = useState('')
    const [loading, setLoading] = useState(false)
    const [success, setSuccess] = useState(false)

    const handleSubmit = async () => {
        setLoading(true)
        if (!email) {
            setError({
                message: 'Please enter a valid email address or username.',
            })
            return
        }
        try {
            const res = await axios.post(urlConfig.forgot, {
                email: email.toLowerCase(),
            })
            if (res.status === 200) {
                setSuccess(true)
            }
        } catch (err) {
            setError({
                message: err.response.data.message || 'Something went wrong',
            })
        } finally {
            setLoading(false)
        }
    }

    return (
        <Modal
            open={open}
            onClose={() => {
                setOpen(false)
                setEmail('')
                setError('')
                setSuccess(false)
            }}
            BackdropProps={{
                sx: { backgroundColor: 'rgba(0, 0, 0, 0.35)' },
            }}
            sx={{ overflowY: 'auto' }}
        >
            <Box
                onSubmit={handleSubmit}
                sx={{
                    minWidth: '300px',
                    maxWidth: success ? '480px' : '400px',
                    position: 'absolute',
                    width: 'auto',
                    bgcolor: 'background.paper',
                    boxShadow: 15,
                    padding: '20px 30px',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    borderRadius: '10px',
                    // overflowY: 'scroll',
                }}
            >
                <Box
                    sx={{
                        fontWeight: '600',
                        fontSize: '24px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginBottom: '15px',
                        color: 'black',
                    }}
                >
                    {success ? 'Check your email' : ' Forgot Password?'}
                </Box>
                {success ? (
                    <>
                        <div style={{ marginTop: '5px', marginBottom: '10px' }}>
                            Password reset instructions have been sent
                            successfully via email.
                        </div>
                        <div style={{ marginTop: '5px', marginBottom: '10px' }}>
                            If you don’t get the email, please check your spam
                            folder.
                        </div>
                        <div style={{ marginTop: '5px', marginBottom: '30px' }}>
                            If you need more help, please contact our support
                            team.
                        </div>
                    </>
                ) : (
                    <>
                        {' '}
                        <label style={{ fontWeight: 'normal' }}>
                            Enter your username or email
                        </label>
                        <OutlinedInput
                            required
                            value={email || ''}
                            onChange={(e) => setEmail(e.target.value)}
                            sx={{ marginTop: '5px', borderRadius: '7px' }}
                            placeholder='username or email'
                            fullWidth
                            size='small'
                        />
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            <Button
                                onClick={() => handleSubmit()}
                                disabled={loading}
                                color='forgot'
                                variant='contained'
                                sx={{
                                    color: 'white',
                                    marginTop: '15px',
                                    textTransform: 'none',
                                    fontWeight: 'normal',
                                    borderRadius: '7px',
                                }}
                            >
                                Send reset instructions
                            </Button>
                        </Box>
                    </>
                )}

                <Box
                    sx={{
                        marginTop: '5px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        fontSize: '14px',
                    }}
                >
                    <Box
                        onClick={() => {
                            setOpen(false)
                            setEmail('')
                            setError('')
                            setSuccess(false)
                        }}
                        sx={{
                            cursor: 'pointer',
                            color: '#706564',
                            '&:hover': {
                                textDecoration: 'underline',
                            },
                        }}
                    >
                        Back to sign in
                    </Box>
                </Box>
            </Box>
        </Modal>
    )
}
